export const LOCALE_NO = {
    ORDER: "Bestilling",
    INVOICE: "Faktura",
    INVOICES: "Fakturaer",
    CREDIT_NOTE: "Kreditnota",
    CREDIT_NOTES: "Kreditnotaer",
    CREATION_DATE: "Utsendelsesdato",
    DELIVERY_DATE: "Leveringsdato",
    DELIVERY_ADDRESS: "Leveringsadresse",
    DELIVERY_COST: "Leveringskostnad",
    VENDOR: "Leverandør",
    CUSTOMER: "Kunde",
    ORDER_NUMBER: "Ordrenummer",
    PAYMENT_METHOD: "Betalingsmetode",
    NOTE: "Merknad",
    PRODUCT: "Vare",
    PRODUCT_DESCRIPTION: "Beskrivelse",
    PRODUCT_AMOUNT: "Antall",
    PRODUCT_SINGLE_PRICE: "Stykkpris",
    DISCOUNT: "Rabatt",
    TOTAL_DISCOUNTS: "Total rabatt",
    TOTAL_BEFORE_DISCOUNTS: "Total før rabatt",
    TAX_ABBREVIATED: "MVA",
    TAX_AMOUNT: "Skattebeløp",
    SPLIT_AMOUNT: "Andel",
    BRUTTO: "Brutto",
    TOTAL: "Total",
    TOTAL_INCLUDING_VAT: "Total inkl. MVA",
    TOTAL_EXCLUDING_VAT: "Total ekskl. MVA",
    VAT_ID: "MVA-ID",
    TAX_ID: "Skatteregistreringsnummer",
    PAID: "Betalt",
    UNPAID_AMOUNT: "Ubetal beløp",
    REASON: "Årsak",
    INVOICE_LINE_ITEMS_TITLE: "Ordreposter",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Kreditnotaer på ordreposter",
    OTHER_CREDIT_NOTES: "Justering av ordren",
    REFUND_SHIPPING_COST: "Returleveringskostnader",
    REFUND_HAS_BEEN_PAID: "Refusjon på $VALUE er betalt.",
    REFUND_HAS_BEEN_PAID_FAILED: "Det oppstod en feil under refusjonen på $VALUE.",
    DOCUMENTS_FOR_ORDER: "Dokumenter for ordren",
    NO_INVOICES: "Ingen fakturaer tilgjengelig ennå",
    NO_CREDIT_NOTES: "Ingen kreditnotaer tilgjengelig ennå",
    DOCUMENTS_ARE_GENERATING: "Fakturadokumenter blir generert for øyeblikket. Prøv igjen om noen minutter.",
    INVALID_REQUEST_PATHWAY_SUPPORT: "Ingen dokumenter ble funnet for denne bestillingen. Vennligst kontakt support@pathway-solutions.de.",
    INVALID_REQUEST_GENERIC: "Ingen dokumenter ble funnet for denne bestillingen. Vennligst kontakt den respektive leverandøren.",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT: "Ingen dokumenter ble funnet for denne bestillingen. Vennligst kontakt ${MAIL}.",
    GIFT_CARD_LINE: "En gavekortkode ${GIFT_CARD_CODE} på ${GIFT_CARD_AMOUNT} ble brukt for denne bestillingen.",
    GIFT_CARD: "Gavekort",
    REVERSAL_INVOICE: "Stornofaktura",
    REVERSAL_CREDIT_NOTE: "Kansellering av kreditnotaen",
    DUTY: "Tollavgift",
    USED_DISCOUNTS: "Anvendte rabatter",
    PAYMENT_AT: "Betaling den $DATE",
    REFUNDED_CREDITNOTE_AT: "Tilbakebetaling av kreditnota $CREDIT_NOTE den $DATE",
    REFUNDED_AT: "Tilbakebetaling den $DATE",
    PROCESSING_DOCUMENT: "Dokumentet behandles",
    DOWNLOAD_DOCUMENTS_TITLE: "Last ned dokumentene dine her!",
    MAIL_INTRODUCTION: "For spørsmål, ta kontakt med ${MAIL}",
    REPAYMENT_DIFFERENCE: "Tilbakebetalingsdifferanse",
    DOCUMENT_PREVIEW_BANNER: "Forhåndsvisning – last ned PDF",
};
